import * as fileSearch from "./fileSearch";
import Tabs from "./tabs";
import touchDevice from "../utils/touchDevice";

const nav = '.js-flies-nav',
    navLink = '.js-files-dropdown',

    submenu = '.js-files-submenu',
    linkSubcat = '.js-files-subcat',
    backToSubcats = '.js-files-back-to-subcats',

    productsContainer = '.js-files-nav-container',
    productsNav = '.js-files-nav-products',

    showAllfromSubcat = '.js-files-all-subcat',
    showAllBtn = '.js-files-all',
    productNavLink = '.js-files-by-product',

    tabClass = '.js-tab',
    tabLink = '.js-files-tab-link';


const init = () => {
    const filesDropdown = () => {
        $(navLink).hover(

            function () {
                if (!touchDevice()) {
                    let attr = $(this).attr('data-cat'),
                        currentSubmenu = $(`${submenu}[data-parent-cat=${attr}]`);
                    if (currentSubmenu.length > 0 && !$(nav).hasClass('active')) {
                        $(this).addClass('hover');
                        $(nav).addClass('hover');
                        $(currentSubmenu).addClass('show').fadeIn(400);
                    }
                }
            },
            function () {
                let attr = $(this).attr('data-cat'),
                    currentSubmenu = $(`${submenu}[data-parent-cat=${attr}]`);

                $(this).removeClass('hover');
                $(nav).removeClass('hover');
                $(currentSubmenu).removeClass('show').fadeOut(400);
            }
        );
    };


    const showProductNav = () => {

        $(linkSubcat).on('click', (ev) => {
            let slug = $(ev.currentTarget).attr('data-subcat'),
                currentNav = $(`${productsNav}[data-name=${slug}]`),
                currentSubmenu = $(ev.currentTarget).parents(submenu),
                parentSlug = currentSubmenu.attr('data-parent-cat'),
                parentLink = $(`${navLink}[data-cat=${parentSlug}]`).children(tabLink);

            $(nav).addClass('active');
            $(parentLink).addClass('hover-for-products');

            if (currentNav.length > 0) {
                currentNav.show();
            } else {
                let data = {
                    action: 'file_nav',
                    slug: slug,
                }

                $.ajax({
                    type: 'POST',
                    url: ajax_url[0],
                    dataType: "html",
                    data: data,
                    success: function (response) {
                        $(productsContainer).append(response);
                        currentNav = $(`${productsNav}[data-name=${slug}]`);
                        currentNav.show();
                    },
                    error: function (error) {
                        console.log('error', error);
                    }
                });
            }
        })
    }

    const updateButtonStatus = (isActive, cat, itemClass, attr) => {
            $(itemClass).each((i, el) => {
                if ($(el).attr(attr) === cat && isActive) {
                    $(el).addClass('active');
                } else {
                    $(el).removeClass('active');
                }
            })
    }

    const updateActive = (cat = '', subcat = '', product = '', allCat = false, allSubcat = false) => {

        if (subcat !== '') {
            let menu = `${navLink}[data-cat=${cat}]`;

            $(linkSubcat).each((i, link) => {
                let currentAttr = $(link).attr('data-subcat');
                if (currentAttr === subcat && $(link).parents(menu).length > 0) {
                    $(link).addClass('active');
                } else {
                    $(link).removeClass('active');
                }
            })
        } else {
            $(linkSubcat).each((i, link) => {
                $(link).removeClass('active');
            });
        }

        if (product !== '') {
            $(productNavLink).each((i, link) => {
                let parentAttr = $(link).attr('data-subcat');
                if ($(link).attr('data-product') === product && $(link).parents(`${productsNav}[data-name=${parentAttr}]`)) {
                    $(link).addClass('active');
                } else {
                    $(link).removeClass('active');
                }
            })
        } else {
            $(productNavLink).each((i, link) => {
                $(link).removeClass('active');
            });
        }

        updateButtonStatus(allCat, cat, showAllBtn, 'data-cat');
        updateButtonStatus(allSubcat, subcat, showAllfromSubcat, 'data-subcat');
    }

    const showAllCatItems = () => {
        $(document).on('click', showAllBtn, (ev) => {
            let slug = $(ev.currentTarget).attr('data-cat'),
                data = {
                    action: 'file_search',
                    slug: slug,
                    query: '',
                };

            let currentSubmenu = $(ev.currentTarget).parents(submenu);

            fileSearch.fileAjax(data, $(`${tabClass}[data-container=${slug}]`), function () {
                $(currentSubmenu).removeClass('hover').fadeOut(400);
                fileTabs.goToTab(slug);
                setTimeout(() => {
                    fileSearch.resetSearch();
                    updateActive(slug, '', '', true, false);
                }, 10)

            })
        })
    }

    const backToSubcategories = () => {
        $(document).on('click', backToSubcats, (ev) => {
            ev.preventDefault();
            let attr = $(ev.currentTarget).attr('data-cat'),
                currentProductNav = $(ev.currentTarget).parents(productsNav),
                currentSubmenu = $(`${submenu}[data-parent-cat=${attr}]`);

            $(currentProductNav).removeClass('show').fadeOut(400);
            $(currentSubmenu).addClass('active').fadeIn(400);
            $(nav).addClass('hover').removeClass('active');
            $(tabLink).each((i, el) => {
                $(el).removeClass('hover-for-products');
            })

        })
    }

    const renderSubcatItems = (target, data, cb) => {
        let currentProductNav = target.parents(productsNav),
            parentCat = target.attr('data-cat'),
            parentLink = $(`${navLink}[data-cat=${parentCat}]`).children(tabLink);

        fileSearch.fileAjax(data, $(`${tabClass}[data-container=${parentCat}]`), function () {
            fileSearch.resetSearch();
            $(currentProductNav).fadeOut(400);
            $(nav).removeClass('active');

            $(parentLink).removeClass('hover-for-products');
            fileTabs.goToTab(parentCat);

            if(cb){
                setTimeout(()=> {
                    cb();
                }, 100)
            }
        })
    }

    const showAllSubCatItems = () => {
        $(document).on('click', showAllfromSubcat, (ev) => {
            let target = $(ev.currentTarget),
                subcat = target.attr('data-subcat'),
                parentCat = target.attr('data-cat'),
                data = {
                    action: 'file_search',
                    slug: subcat,
                    query: '',
                };
            renderSubcatItems(target, data, () => {
                updateActive(parentCat, subcat, '', false, true)
            });

        })
    }

    const showProductSubCatItems = () => {
        $(document).on('click', productNavLink, (ev) => {
            let target = $(ev.currentTarget),
                subcat = target.attr('data-subcat'),
                parentCat = target.attr('data-cat'),
                product = target.attr('data-product'),
                field = target.attr('data-field'),
                data = {
                    action: 'file_search',
                    slug: subcat,
                    query: '',
                    product: product,
                    field: field,
                };

            renderSubcatItems(target, data, () => {
                updateActive(parentCat, subcat, product)
            });
        })
    }

    const showCatItems = () => {
        $(document).on( 'click', '.js-search-by-cat, .js-file-cat-return', (ev) => {
            let target = $(ev.currentTarget),
                subcat = target.attr('data-subcat'),
                parentCat = target.attr('data-cat'),
                // product = target.attr('data-product'),
                data = {
                    action: 'file_search',
                    slug: subcat,
                    query: '',
                };

            console.log( subcat );
            console.log( parentCat );

            renderSubcatItems(target, data, () => {
                updateActive(parentCat, subcat)
            });
        } );

    }

    const fileTabs = new Tabs('.js-files-tab-link', updateActive); //reset active classes
    fileTabs.init();
    fileSearch.initSearch(updateActive); //reset active classes

    // filesDropdown();
    // showProductNav();
    // backToSubcategories();
    // showAllCatItems();
    // showProductSubCatItems();
    // showAllSubCatItems();
    showCatItems();
}

export default init;